import React, { useState, useEffect } from "react";
// import "./modal.css";
import Services from "../../services";
import FormatDate from '../../common/FormatDate'
import nhanVienUtil from "../utilities/module/NhanVien";
import { useDispatch } from 'react-redux'
import allActions from "../../store/redux-actions";
const CapNhatTaiKhoanModal = ({ nhanVienUp}) => {
    const dispatch = useDispatch()
    const [nhanVien, setNhanVien] = useState(nhanVienUtil.getNhanVien());
    const [error, setError] = useState("");
    var isMounted = true;
    useEffect(() => {
        setNhanVien(nhanVienUp);
        isMounted = true;
        return () => { isMounted = false };
    }, []);
    function onChange(e, arr) {
        
            if (e.target.name == 'hoTen') {
                setNhanVien((nhanVien) => ({ ...nhanVien, hoTen: e.target.value }));
            } else if (e.target.name == 'gioiTinh') {
                setNhanVien((nhanVien) => ({ ...nhanVien, gioiTinh: e.target.value }));
            } else if (e.target.name == 'diaChi') {
                setNhanVien((nhanVien) => ({ ...nhanVien, diaChi: e.target.value }));
            } else if (e.target.name == 'soCMND') {
                setNhanVien((nhanVien) => ({ ...nhanVien, soCMND: e.target.value }));
            } else if (e.target.name == 'soDienThoai') {
                setNhanVien((nhanVien) => ({ ...nhanVien, soDienThoai: e.target.value }));
            } else if (e.target.name == 'ngaySinh') {
                setNhanVien((nhanVien) => ({ ...nhanVien, ngaySinh: FormatDate.setTimeZoneUTC7(e.target.value) }));
            } else if (e.target.name == 'email') {
                setNhanVien((nhanVien) => ({ ...nhanVien, email: e.target.value }));
            }
        setError("")
    }
    function kiemtraNV() {
        let error = nhanVienUtil.kiemTaNhanVien(nhanVien);
        if (error == "") {
            return true;
        } else {
            setError(error);
            return false;
        }

    }
    function capNhatNV() {
        if (kiemtraNV()) {
            Services.getTaiKhoanService().capNhatThongTinCaNhan(nhanVien).then(
                (response) => {
                    if (response.data != null) {
                        if(response.data.noiDung== undefined){
                            thoat();
                            window.location.reload();
                        }
                        else setError(response.data.noiDung);
                    }
                },
                (error) => {
                }
            )
        };
    }
    function thoat() {
        dispatch(allActions.displayModalActions.setDisplay(null))
    }
    return (
        <div className="modal" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true" >
            <div className="modal-dialog modal-md" style={{ maxWidth: "650px" }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{nhanVien._id == undefined ? "THÊM NHÂN VIÊN MỚI" : "CẬP NHẬT NHÂN VIÊN"}</h5>
                        <button type="button" className="close" data-dismiss="modal" onClick={(e) => { thoat() }}>×</button>

                    </div>
                    <div className="modal-body">
                        <form className="row" action="/">
                            <div className="row col-12 col-lg-12" >

                                <table >
                                    <tbody>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Họ tên:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <input type="text" defaultValue={nhanVien.hoTen == null ? '' : nhanVien.hoTen} className="form-control form-control-lg" name="hoTen" onInput={(e) => { onChange(e) }} placeholder="Nhập họ và tên nhân viên" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Email:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className="input-m form-check form-switch">
                                                    <input type="text" defaultValue={nhanVien.email == null ? '' : nhanVien.email} className="form-control form-control-lg" name="email" onInput={(e) => { onChange(e) }} placeholder="Nhập email của Vnpt" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 ><span className="red">* </span>Số điện thoại:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <input type="text" defaultValue={nhanVien.soDienThoai == null ? '' : nhanVien.soDienThoai} className="form-control form-control-lg" name="soDienThoai" onInput={(e) => { onChange(e) }} placeholder="Nhập số điện thoại" />

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 >Số CMND/ CCCD:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className="input-m form-check form-switch">
                                                    <input type="text" defaultValue={nhanVien.soCMND == null ? '' : nhanVien.soCMND} className="form-control form-control-lg" name="soCMND" onInput={(e) => { onChange(e) }} placeholder="Nhập số CMND hoặc CCCD" />
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 >Giới tính:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className="input-m form-check form-switch pt-1">
                                                    <input type="radio" checked={nhanVien.gioiTinh == "Nam"} className="me-1" value="Nam" name="gioiTinh" onChange={(e) => { onChange(e) }} />Nam
                                                    <input type="radio" checked={nhanVien.gioiTinh == "Nữ"} className="ms-5 me-1" value="Nữ" name="gioiTinh" onChange={(e) => { onChange(e) }} />Nữ

                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-right"> <h5 >Ngày sinh:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className="input-m form-check form-switch">
                                                    <input defaultValue={nhanVienUp.ngaySinh ? nhanVienUp.ngaySinh : "1995-01-01"} name="ngaySinh" onInput={(e) => { onChange(e) }} className="form-control form-control-lg" type="date" />

                                                </span>
                                            </td>
                                        </tr>
                                        
                                        <tr>
                                            <td className="text-right"> <h5 >Địa chỉ:</h5> </td>
                                            <td colSpan="3" className="text-left">
                                                <span className=" input-m form-check form-switch">
                                                    <textarea defaultValue={nhanVien.diaChi == null ? '' : nhanVien.diaChi} className="form-control form-control-lg" rows="2" name="diaChi" onInput={(e) => { onChange(e) }} placeholder="Nhập địa chỉ thường trú" style={{ height: "50px" }}></textarea>

                                                </span>
                                            </td>
                                        </tr>
                                       
                                        {nhanVien._id == undefined ? null :
                                            <tr>
                                                <td className="text-right"> <h5 ><span className="red">* </span>Lưu ý:</h5> </td>
                                                <td colSpan="3" className="text-left">
                                                    <span className=" input-m form-check form-switch">
                                                        <i>Khi cập nhật địa chỉ email, SĐT hoặc mật khẩu thì tài khoản sẽ phải đăng nhập lại
                                                        </i>
                                                    </span>
                                                </td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>

                        </form>


                    </div>
                    <div className="modal-footer">
                        <div><i className="red">{error}</i></div>
                         <button onClick={(e) => { capNhatNV() }} className="btn btn-primary me-1">Cập nhật</button>
                        <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e) => { thoat() }}>Thoát</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CapNhatTaiKhoanModal;